<template>
    <div>
        <div v-if="loading" class="loading"/>

        <div v-else class="disable-text-selection">
            <div class="top-right-button-container">
                <b-button @click="printSignatures" size="sm" variant="primary">
                    Print
                </b-button>
            </div>

            <div class="d-flex flex-row mb-2">
                <span class="iconsminds-coins mr-3 menu-icon-style" style="font-size: 23px;"/>

                <piaf-breadcrumb :heading="signature.data.attributes.code"/>

<!--                <p class="my-auto">-->
<!--                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi dolores quod,-->
<!--                    repellendus similique sint. Ad, corporis culpa delectus est in ipsum laboriosam nostrum-->
<!--                    officiis quia quos rem totam vitae.-->
<!--                </p>-->
            </div>

            <div class="separator mb-4"/>

            <b-row class="invoice-vue" id="print-signatures">
                <b-colxx md="12">
                    <b-card no-body>
                        <b-card-body class="d-flex flex-column justify-content-between">
                            <div class="d-flex flex-row justify-content-between mb-5">
                                <div class="d-flex flex-column w-70 mr-2 p-4 text-semi-muted bg-semi-muted">
                                    <p class="mb-0">Code: {{ signature.data.attributes.code }}</p>
                                    <p class="mb-0">Facility Code: {{ signature.data.attributes.facility_code }}</p>
                                    <p class="mb-0">Facility Name: {{ signature.data.attributes.facility }}</p>
                                    <p class="mb-0">Address: {{ signature.data.attributes.address }}</p>
                                </div>

                                <div class="d-flex w-30 flex-column text-right p-4 text-semi-muted bg-semi-muted">
                                    <p class="mb-0">Date: {{ signature.data.attributes.date }}</p>
                                    <p class="mb-0">Total Occupied: {{ signature.data.attributes.occupied_units }}</p>
                                    <p class="mb-0">Signature Recieved: {{ signature.data.attributes.total_signed }}</p>
                                    <p class="mb-0">Sign Percentage: {{ signature.data.attributes.sign_percentage }}</p>
                                </div>
                            </div>

                            <table class="table">
                                <thead>
                                <tr>
                                    <th class="text-muted mb-2">#</th>
                                    <th class="text-muted mb-2">FLOOR</th>
                                    <th class="text-muted mb-2">UNIT</th>
                                    <th class="text-muted mb-2">STATUS</th>
                                    <th class="text-muted mb-2">REMARKS</th>
                                </tr>
                                </thead>

                                <tbody>
                                <tr v-for="(content, index) in signature.data.attributes.contents.data">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ content.data.attributes.floor }}</td>
                                    <td>{{ content.data.attributes.unit }}</td>
                                    <td>{{ content.data.attributes.status }}</td>
                                    <td>{{ content.data.attributes.remarks }}</td>
                                </tr>
                                </tbody>
                            </table>

                            <b-row>
                                <b-colxx md="12">
                                    <table>
                                        <tbody>
                                        <tr>
                                            <td>
                                                <p class="font-weight-bold">NOTES:</p>
                                                <p>{{ signature.data.attributes.notes }}</p>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </b-colxx>
                            </b-row>

                            <div class="border-bottom pt-3 mb-5"></div>

                            <p class="text-muted text-small text-center">
                                Updated by: {{ signature.data.attributes.updated_by }}, Updated at:
                                {{ signature.data.attributes.updated_at }}</p>
                        </b-card-body>
                    </b-card>
                </b-colxx>
            </b-row>

            <b-row class="mt-4 mb-n4" v-if="!loadingFiles">
                <b-colxx md="12">
                    <div>
                        <div class="d-flex flex-row">
                            <div class="my-auto">
                                <div class="d-inline-block mb-3">
                                    <h5 class="d-inline">Attachments</h5>
                                </div>
                            </div>
                        </div>

                        <p v-if="files.length < 1">
                            No attachments to show
                        </p>

                        <FilesList :files="files" @delete="deleteFile"/>

                        <FileDelete v-if="file" :file="file" :base-url="base_url" @updated="getFiles($route.params.signature_id)"/>
                    </div>
                </b-colxx>
            </b-row>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import FilesList from "../../../../components/Listing/FilesList";
import FileDelete from "../../../../components/Modal/FileDelete";

export default {
    name: "SignatureSummary",

    components: {
      FilesList,
      FileDelete,
    },

    data() {
        return {
            loading: true,
            loadingFiles: true,
            themeMode: localStorage.getItem('theme_selected_color').split(".")[0],
            base_url: '/api/hms/signatures/' + this.$route.params.signature_id + '/attachments',
            file: null,
        }
    },

    computed: {
        ...mapGetters({
            signature: 'getSignature',
            files: 'getSignatureFiles'
        })
    },

    mounted() {
        this.getSignature(this.$route.params.signature_id);
        this.getFiles(this.$route.params.signature_id);
    },

    methods: {
        async getSignature(signature_id) {
            await this.$store.dispatch('fetchSignature', signature_id)
                .catch(error => {
                    this.$router.push('/error');
                });

            return this.loading = false;
        },

        async getFiles(signature_id) {
            await this.$store.dispatch('fetchSignatureFiles', signature_id);

            return this.loadingFiles = false;
        },

        deleteFile(file) {
            this.file = file;

            setTimeout(() => {
                this.$bvModal.show('file_delete');
            }, 1);
        },

        printSignatures() {
            this.$htmlToPaper('print-signatures');
        }
    }
}
</script>

<style scoped>

</style>
